import React from 'react';
import cls from './LabeledField.module.scss';
import {errorInfo} from '../../../../assets/images/new-icons';
import {RenderTitle} from "../../TwoStatesFieldWrapper/FieldWrapper";

const LabeledField = (props) => {
    const { label, error, mandatory, children, tooltipText, setMinWidth, labelStyle } = props;
    const hasError = error?.length > 0;
    // Function to clone children and add the is-errored prop if they are input elements
    const renderChildren = () => {
        return React.Children.map(children, (child) => {
            if (child?.type === 'input') {
                return React.cloneElement(child, {
                    'is-errored': hasError ? 'error' : '',
                });
            }

            return child;
        });
    };

    return (
        <div className={cls.labeledFieldHost}>
            {label && <RenderTitle hasError={hasError} title={label} required={mandatory} tooltipText={tooltipText && tooltipText} setMinWidth = {setMinWidth}/>}
            {renderChildren()}
            {hasError && <p className={cls.error}><span><img alt="" src={errorInfo} /></span>{error}</p>}
        </div>
    );
};

export default LabeledField;
